import React from 'react';

import { Grid } from '@mui/material';

import PageHeader from '../../components/common/PageHeader';
import ServiceHistoryCardList from './components/ServiceHistoryCardList';

function RouteStopList() {
  return (
    <React.Fragment>
      <PageHeader title="Service History" />

      <Grid container spacing={6}>
        <Grid item xs={12}>
          <ServiceHistoryCardList />
        </Grid>
      </Grid>
    </React.Fragment>
  );
}

export default RouteStopList;
